import { IListItemWithKmlUrl } from "../../schemas/IListItemWithKmlUrl";

export const getSurvey = (surveyNumber: string, surveys?: IListItemWithKmlUrl[]) =>
  surveys?.find((survey) => survey.itemNumber === surveyNumber);
